import { Box, Chip, Menu, Stack, Typography } from '@mui/material'
import { MouseEvent, useState } from 'react'

import APiDocLinksV2 from '../ApiDocLinksV2'
import ApiDocLinksV1 from '../ApiDocLinksV1'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { MenuItem } from '@mui/material'

enum ApiVersion {
  V1 = 'V1',
  V2 = 'V2'
}

type VersionType = keyof typeof ApiVersion

const ApiDocsVersionToggle = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [version, setVersion] = useState<VersionType>(ApiVersion.V1)

  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClick = (version: VersionType) => {
    setVersion(version)
    handleClose()
  }

  return (
    <>
      {/* TODO (SPD-554): remove this condition once V2 is ready to go live */}
      {process.env.REACT_APP_V2_VERSION_ENABLED === 'true' && (
        <>
          <Chip
            label={
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography fontSize="inherit">{version}</Typography>
                <Box>
                  <KeyboardArrowDownIcon sx={{ color: 'rgba(255, 255, 255, 0.5)' }} />
                </Box>
              </Stack>
            }
            onClick={handleMenu}
            aria-label="account of current user"
            aria-controls="menu-version"
            aria-haspopup="true"
            sx={{
              color: 'white',
              width: '64px',
              height: '24px',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '10px'
            }}
            size="medium"
            variant="filled"
            data-testid="version-toggle"
          />
          <Menu
            id="menu-version"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            sx={{
              ml: '6px',
              mt: '5px'
            }}
          >
            {(Object.keys(ApiVersion) as Array<VersionType>).map((key) => (
              <MenuItem
                key={key}
                onClick={() => handleClick(key)}
                sx={{ color: key === version ? 'primary.main' : 'inherit' }}
                data-testid={`${key}-menu-item`}
              >
                {key}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}

      <>{version === ApiVersion.V1 ? <ApiDocLinksV1 /> : <APiDocLinksV2 />}</>
    </>
  )
}

export default ApiDocsVersionToggle
